// Holds the host's read-only world view + identity for the duration of a visit.
export const visitState = {
  hostId: null,
  hostName: null,
  view: null,     // the /visit payload
  reset() { this.hostId = this.hostName = this.view = null; },
  // Read the host's world again. A failed read keeps what we have; an answer from a visit that has moved on is dropped.
  async reread(read) {
    const hostId = this.hostId;
    let view;
    try { view = await read(hostId); } catch { return; }
    if (this.hostId === hostId) this.view = view;
  },
};
